import { NavLink } from "react-router-dom";

interface BreadcrumbsProps {
  breadcrumbs: { name: string; href: string }[];
}

function BreadCrumbs({ breadcrumbs }: BreadcrumbsProps) {
  return (
    <div className="flex items-center gap-2">
      {breadcrumbs.map(({ name, href }, index) => (
        <div className="flex items-center gap-2 text-cool-gray-600" key={index}>
          <NavLink to={href}>{name}</NavLink>
          {index !== breadcrumbs.length - 1 && <span>/</span>}
        </div>
      ))}
    </div>
  );
}

export default BreadCrumbs;
